import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    MobileNavbarMenuWrapper,
    MobileNavbarMenuItem,
    MobileNavbarProfilePicture,
    MobileNavbarMenuWrapperNotLoggedIn,
    MobileNavbarMenuItemLogIn,
    MobileNavbarProfilePictureWrapper,
    MobileNavbarMenuSVG,
} from "./mobileNavbarStyling";
import { userModelSelector } from "../../../state/selectors/userModel";
import { userHostModelSelector } from "../../../state/selectors/userHostModel";
import { signInMenuActivatedSelector } from "../../../state/selectors/navbarToggle";
import { useRecoilState } from "recoil";
import { useEffect } from "react";
import { ColorTheme } from "../../globaStyledComponents/globalStyledComponentsStyling";
import { searchFiltersSelector } from "../../../state/selectors/searchQuery";
import constructOptimisedProtectedImageUrl from "../../../utils/imageOptimisation/constructOptimisedProtectedImageUrl";

export default function MobileNavbarMenuItems() {
    const navigate = useNavigate();
    const [userModel] = useRecoilState(userModelSelector);
    const [userHostModel] = useRecoilState(userHostModelSelector);
    const [, setSignInMenuActivated] = useRecoilState(signInMenuActivatedSelector);
    const [profilePicture, setProfilePicture] = useState("https://d292awxalydr86.cloudfront.net/Settings+page/Profile+photo+placeholder.png");

    let currentIndex = 1;
    if (window.location.href.includes("/saved")) {
        currentIndex = 2;
    } else if (window.location.href.includes("/trips")) {
        currentIndex = 3;
    } else if (window.location.href.includes("/messages-lite")) {
        currentIndex = 4;
    } else if (window.location.href.includes("/profile")) {
        currentIndex = 5;
    } else if (window.location.href.includes("/dashboard")) {
        currentIndex = 6;
    } else if (window.location.href.includes("/inbox-lite")) {
        currentIndex = 7;
    } else if (window.location.href.includes("/calendar")) {
        currentIndex = 8;
    } else if (window.location.href.includes("/listings")) {
        currentIndex = 9;
    }

    useEffect(() => {
        if (userModel && userModel.profilePicture) {
            const profilePic = constructOptimisedProtectedImageUrl(userModel.profilePicture, userModel.identityID, 100);
            setProfilePicture(profilePic);
        }
    }, [userModel]);

    // const handleMenuItemInteraction = () => {
    //     const searchFiltersCopy = JSON.parse(JSON.stringify(searchFilters));
    //     category removed
    //     setSearchFilters(searchFiltersCopy);
    //     navigate("/");
    // };

    if (userModel) {
        if (userModel.guestMode) {
            return (
                <MobileNavbarMenuWrapper>
                    <MobileNavbarMenuItemNav url="/" text={"Home"} alt={"Search button"} currentIndex={currentIndex} color={currentIndex === 1 ? ColorTheme.Black.color : ColorTheme.Grey.color} />
                    <MobileNavbarMenuItemNav
                        url={`/saved/${userModel.id}`}
                        text={"Wishlists"}
                        alt={"Wishlists button"}
                        currentIndex={currentIndex}
                        color={currentIndex === 2 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                    />

                    <MobileNavbarMenuItemNav
                        url={`/trips/${userModel.id}`}
                        text={"Trips"}
                        alt={"Trips button"}
                        currentIndex={currentIndex}
                        color={currentIndex === 3 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                    />
                    <MobileNavbarMenuItemNav
                        url={`/messages-lite/${userModel.id}`}
                        text={"Messages"}
                        alt={"Inbox button"}
                        currentIndex={currentIndex}
                        color={currentIndex === 4 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                    />
                    <MobileNavbarMenuItem
                        onTouchEnd={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            navigate("/profile");
                        }}
                        onClick={() => {
                            navigate("/profile");
                        }}
                    >
                        <MobileNavbarProfilePictureWrapper selected={currentIndex === 5}>
                            <MobileNavbarProfilePicture src={profilePicture} alt="profile picture" />
                        </MobileNavbarProfilePictureWrapper>
                    </MobileNavbarMenuItem>
                </MobileNavbarMenuWrapper>
            );
        } else {
            return (
                <MobileNavbarMenuWrapper>
                    <MobileNavbarMenuItemNav
                        url="/dashboard"
                        text={"Home"}
                        alt={"Host Home button"}
                        currentIndex={currentIndex}
                        color={currentIndex === 6 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                    />
                    <MobileNavbarMenuItemNav
                        url={`/inbox-lite/${userHostModel ? userHostModel.id : ""}`}
                        text={"Inbox"}
                        alt={"Inbox button"}
                        currentIndex={currentIndex}
                        color={currentIndex === 7 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                    />
                    <MobileNavbarMenuItemNav
                        url="/calendar"
                        text={"Calendar"}
                        alt={"Calendar button"}
                        currentIndex={currentIndex}
                        color={currentIndex === 8 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                    />
                    <MobileNavbarMenuItemNav
                        url={`/listings/${userHostModel ? userHostModel.id : ""}`}
                        text={"Listings"}
                        alt={"Listings button"}
                        currentIndex={currentIndex}
                        color={currentIndex === 9 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                    />
                    <MobileNavbarMenuItem
                        onTouchEnd={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            navigate("/profile");
                        }}
                        onClick={() => {
                            navigate("/profile");
                        }}
                    >
                        <MobileNavbarProfilePictureWrapper selected={currentIndex === 5}>
                            <MobileNavbarProfilePicture src={profilePicture} alt="profile picture" />
                        </MobileNavbarProfilePictureWrapper>
                    </MobileNavbarMenuItem>
                </MobileNavbarMenuWrapper>
            );
        }
    } else {
        return (
            <MobileNavbarMenuWrapperNotLoggedIn>
                <MobileNavbarMenuItemNav url="/" text={"Home"} alt={"Search button"} currentIndex={currentIndex} color={currentIndex === 1 ? ColorTheme.Black.color : ColorTheme.Grey.color} />
                <MobileNavbarMenuItemNav
                    url={"/saved"}
                    text={"Wishlists"}
                    alt={"Wishlists button"}
                    currentIndex={currentIndex}
                    color={currentIndex === 2 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                />

                <MobileNavbarMenuItemNav
                    url={"/trips"}
                    text={"Trips"}
                    alt={"Trips button"}
                    currentIndex={currentIndex}
                    color={currentIndex === 3 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                />
                <MobileNavbarMenuItemNav
                    url={`/messages-lite`}
                    text={"Messages"}
                    alt={"Inbox button"}
                    currentIndex={currentIndex}
                    color={currentIndex === 4 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                />
                <MobileNavbarMenuItemLogIn
                    stroke={ColorTheme.Grey1.color}
                    onTouchEnd={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        setSignInMenuActivated(true);
                    }}
                    onClick={() => {
                        setSignInMenuActivated(true);
                    }}
                >
                    <svg 
                        aria-label="Profile" 
                        role="img" 
                        viewBox="0 0 26 26" 
                        style={{
                            height: "24px",
                            width: "24px",
                            objectFit: "cover",
                            border: "none"
                        }}
                    >
                        <title>Profile</title>
                        <circle 
                            cx="13" 
                            cy="7.25" 
                            r="4" 
                            fill="none"
                            stroke={ColorTheme.Grey1.color}
                            strokeWidth="2.5"
                        />
                        <path 
                            d="M6.26678 23.75H19.744C21.603 23.75 22.5 23.2186 22.5 22.0673C22.5 19.3712 18.8038 15.75 13 15.75C7.19625 15.75 3.5 19.3712 3.5 22.0673C3.5 23.2186 4.39704 23.75 6.26678 23.75Z" 
                            fill="none"
                            stroke={ColorTheme.Grey1.color}
                            strokeWidth="2.5"
                        />
                    </svg>
                </MobileNavbarMenuItemLogIn>
            </MobileNavbarMenuWrapperNotLoggedIn>
        );
    }
}

interface MobileNavbarMenuItemProps {
    text: string;
    currentIndex: number;
    alt: string;
}

function MobileNavbarMenuItemSVG({ text, currentIndex, alt }: MobileNavbarMenuItemProps) {
    if (text === "Home" && alt === "Search button") {
        return (
            <MobileNavbarMenuSVG 
                xmlns="http://www.w3.org/2000/svg" 
                width="24" 
                height="24" 
                viewBox="0 0 26 26" 
                fill="none" 
                aria-label="Home" 
                role="img"
            >
                <title>Home</title>
                {currentIndex === 1 ? (
                    <path
                        d="M2.25 12.8855V20.7497C2.25 21.8543 3.14543 22.7497 4.25 22.7497H8.25C8.52614 22.7497 8.75 22.5259 8.75 22.2497V17.6822V17.4997C8.75 15.1525 10.6528 13.2497 13 13.2497C15.3472 13.2497 17.25 15.1525 17.25 17.4997V17.6822V22.2497C17.25 22.5259 17.4739 22.7497 17.75 22.7497H21.75C22.8546 22.7497 23.75 21.8543 23.75 20.7497V12.8855C23.75 11.3765 23.0685 9.94815 21.8954 8.99883L16.1454 4.3454C14.3112 2.86095 11.6888 2.86095 9.85455 4.3454L4.10455 8.99883C2.93153 9.94815 2.25 11.3765 2.25 12.8855Z"
                        fill={ColorTheme.Black.color}
                        stroke={ColorTheme.Black.color}
                        strokeWidth="2.5"
                        strokeLinecap="round"
                    />
                ) : (
                <path
                        d="M2.25 12.8855V20.7497C2.25 21.8543 3.14543 22.7497 4.25 22.7497H9.25C9.52614 22.7497 9.75 22.5258 9.75 22.2497V17.6822V16.4997C9.75 14.7048 11.2051 13.2497 13 13.2497C14.7949 13.2497 16.25 14.7048 16.25 16.4997V17.6822V22.2497C16.25 22.5258 16.4739 22.7497 16.75 22.7497H21.75C22.8546 22.7497 23.75 21.8543 23.75 20.7497V12.8855C23.75 11.3765 23.0685 9.94814 21.8954 8.99882L16.1454 4.34539C14.3112 2.86094 11.6888 2.86094 9.85455 4.34539L4.10455 8.99882C2.93153 9.94814 2.25 11.3765 2.25 12.8855Z"
                        fill="none"
                        stroke={ColorTheme.Grey1.color}
                        strokeWidth="2.5"
                    strokeLinecap="round"
                />
                )}
            </MobileNavbarMenuSVG>
        );
    }
    if (text === "Wishlists") {
        return (
            <MobileNavbarMenuSVG aria-label={alt} role="img" viewBox="0 0 26 26" width="24" height="24" fill={currentIndex === 2 ? ColorTheme.Black.color : "transparent"}>
                <title>Wishlists</title>
                <path d="M2.5 9.85683C2.5 14.224 6.22178 18.5299 12.0332 22.2032C12.3554 22.397 12.7401 22.5909 13 22.5909C13.2703 22.5909 13.655 22.397 13.9668 22.2032C19.7782 18.5299 23.5 14.224 23.5 9.85683C23.5 6.11212 20.8698 3.5 17.4599 3.5C15.4847 3.5 13.9356 4.39792 13 5.74479C12.0851 4.40812 10.5257 3.5 8.5401 3.5C5.14059 3.5 2.5 6.11212 2.5 9.85683Z" stroke={currentIndex === 2 ? ColorTheme.Black.color : ColorTheme.Grey1.color} strokeWidth="2.5" />
            </MobileNavbarMenuSVG>
        );
    }
    if (text === "Trips") {
        return (
            <MobileNavbarMenuSVG 
                xmlns="http://www.w3.org/2000/svg" 
                width="24" 
                height="24" 
                viewBox="0 0 27 28" 
                fill="none" 
                aria-label={alt} 
                role="img"
            >
                <title>Trips</title>
                <path 
                    d="M17.8365 11.5942C17.8365 13.8033 15.8592 15.5942 13.42 15.5942C10.9808 15.5942 9.0035 13.8033 9.0035 11.5942M17.8365 7.59417V5.87988C17.8365 3.67074 15.8592 1.87988 13.42 1.87988C10.9808 1.87988 9.00351 3.67074 9.00351 5.87988V7.59417M9.49147 25.8799H17.3486C21.7158 25.8799 25.1774 22.5426 24.905 18.595L24.2937 9.7373C24.2106 8.53265 23.1076 7.59417 21.7749 7.59417H5.06512C3.73243 7.59417 2.62944 8.53265 2.54631 9.7373L1.93506 18.595C1.66264 22.5426 5.12427 25.8799 9.49147 25.8799Z" 
                    stroke={currentIndex === 3 ? ColorTheme.Black.color : ColorTheme.Grey1.color}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                />
            </MobileNavbarMenuSVG>
        );
    }
    if (text === "Messages") {
        return (
            <MobileNavbarMenuSVG xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 23" fill="none" aria-label="Messages" role="img" style={{height: "24px", width: "24px", objectFit: "cover", border: "none"}}>
                <title>Messages</title>
                <path d="M18.68 1H5.32C4.30687 1 3.33524 1.38287 2.61885 2.06439C1.90246 2.7459 1.5 3.67023 1.5 4.63404V13.7096C1.5 14.6734 1.90246 15.5978 2.61885 16.2793C3.33524 16.9608 4.30687 17.3437 5.32 17.3437H9.14L12 21L14.86 17.3437H18.68C19.6931 17.3437 20.6648 16.9608 21.3811 16.2793C22.0975 15.5978 22.5 14.6734 22.5 13.7096V4.63404C22.5 3.67023 22.0975 2.7459 21.3811 2.06439C20.6648 1.38287 19.6931 1 18.68 1Z" stroke={currentIndex === 4 ? ColorTheme.Black.color : "#cccccc"} strokeWidth="2.2" strokeMiterlimit="10"/>
            </MobileNavbarMenuSVG>
        );
    }
    if (text === "Home" && alt === "Host Home button") {
        return (
            <MobileNavbarMenuSVG width="24" height="24" viewBox="0 0 24 24" fill="none" aria-label={alt}>
                <path
                    d="M2.82495 10.1896L3.42576 10.8597H3.42576L2.82495 10.1896ZM9.36787 22.2007V23.1007H10.2679V22.2007H9.36787ZM15.6287 22.2007H14.7287V23.1007H15.6287V22.2007ZM22.1048 10.1896L22.7057 9.51954V9.51954L22.1048 10.1896ZM13.6665 2.62387L13.0657 3.29396V3.29396L13.6665 2.62387ZM11.2633 2.62387L11.8641 3.29396L11.2633 2.62387ZM3.12656 11.5298C3.12656 11.2741 3.23535 11.0305 3.42576 10.8597L2.22414 9.51954C1.65293 10.0317 1.32656 10.7627 1.32656 11.5298H3.12656ZM3.12656 20.4007V11.5298H1.32656V20.4007H3.12656ZM4.02656 21.3007C3.52951 21.3007 3.12656 20.8978 3.12656 20.4007H1.32656C1.32656 21.8919 2.53539 23.1007 4.02656 23.1007V21.3007ZM9.36787 21.3007H4.02656V23.1007H9.36787V21.3007ZM10.2679 22.2007V17.215H8.46787V22.2007H10.2679ZM10.2679 17.215C10.2679 15.9831 11.2665 14.9845 12.4983 14.9845V13.1845C10.2724 13.1845 8.46787 14.989 8.46787 17.215H10.2679ZM12.4983 14.9845C13.7301 14.9845 14.7287 15.9831 14.7287 17.215H16.5287C16.5287 14.989 14.7242 13.1845 12.4983 13.1845V14.9845ZM14.7287 17.215V22.2007H16.5287V17.215H14.7287ZM20.9032 21.3007H15.6287V23.1007H20.9032V21.3007ZM21.8032 20.4007C21.8032 20.8978 21.4003 21.3007 20.9032 21.3007V23.1007C22.3944 23.1007 23.6032 21.8919 23.6032 20.4007H21.8032ZM21.8032 11.5298V20.4007H23.6032V11.5298H21.8032ZM21.504 10.8597C21.6944 11.0305 21.8032 11.2741 21.8032 11.5298H23.6032C23.6032 10.7627 23.2769 10.0317 22.7057 9.51954L21.504 10.8597ZM13.0657 3.29396L21.504 10.8597L22.7057 9.51954L14.2673 1.95377L13.0657 3.29396ZM11.8641 3.29396C12.206 2.98743 12.7238 2.98743 13.0657 3.29396L14.2673 1.95377C13.2417 1.03416 11.6881 1.03416 10.6625 1.95377L11.8641 3.29396ZM3.42576 10.8597L11.8641 3.29396L10.6625 1.95377L2.22414 9.51954L3.42576 10.8597Z"
                    fill={currentIndex === 6 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                    strokeWidth="26"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
            </MobileNavbarMenuSVG>
        );
    }
    if (text === "Inbox") {
        return (
            <MobileNavbarMenuSVG width="24" height="24" viewBox="0 0 24 24" fill="none" aria-label={alt}>
                <path
                    id="Vector"
                    d="M18.9981 1.5H5.00191C3.94053 1.5 2.92263 1.90201 2.17213 2.6176C1.42163 3.3332 1 4.30374 1 5.31574V14.8451C1 15.8571 1.42163 16.8277 2.17213 17.5432C2.92263 18.2588 3.94053 18.6608 5.00191 18.6608H9.00381L12 22.5L14.9962 18.6608H18.9981C20.0595 18.6608 21.0774 18.2588 21.8279 17.5432C22.5784 16.8277 23 15.8571 23 14.8451V5.31574C23 4.30374 22.5784 3.3332 21.8279 2.6176C21.0774 1.90201 20.0595 1.5 18.9981 1.5Z" stroke={currentIndex === 7 ? ColorTheme.Black.color : ColorTheme.Grey.color} strokeWidth="1.6" strokeMiterlimit="10" />
            </MobileNavbarMenuSVG>
        );
    }
    if (text === "Calendar") {
        return (
            <MobileNavbarMenuSVG width="24" height="24" viewBox="0 0 22 22" fill="none" aria-label={alt}>
                <g clipPath="url(#clip0_63738_12150)">
                    <path
                        d="M18.75 0C20.5449 0 22 1.45507 22 3.25V18.75C22 20.5449 20.5449 22 18.75 22H3.25C1.45507 22 0 20.5449 0 18.75V3.25C0 1.45507 1.45507 0 3.25 0H18.75ZM18.75 1.5H3.25C2.2835 1.5 1.5 2.2835 1.5 3.25V18.75C1.5 19.7165 2.2835 20.5 3.25 20.5H18.75C19.7165 20.5 20.5 19.7165 20.5 18.75V3.25C20.5 2.2835 19.7165 1.5 18.75 1.5Z"
                        fill={currentIndex === 8 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                    />
                    <path
                        d="M5.5 6.5C6.32843 6.5 7 7.17157 7 8C7 8.82843 6.32843 9.5 5.5 9.5C4.67157 9.5 4 8.82843 4 8C4 7.17157 4.67157 6.5 5.5 6.5ZM11 6.5C11.8284 6.5 12.5 7.17157 12.5 8C12.5 8.82843 11.8284 9.5 11 9.5C10.1716 9.5 9.5 8.82843 9.5 8C9.5 7.17157 10.1716 6.5 11 6.5ZM16.5 6.5C17.3284 6.5 18 7.17157 18 8C18 8.82843 17.3284 9.5 16.5 9.5C15.6716 9.5 15 8.82843 15 8C15 7.17157 15.6716 6.5 16.5 6.5ZM5.5 12.5C6.32843 12.5 7 13.1716 7 14C7 14.8284 6.32843 15.5 5.5 15.5C4.67157 15.5 4 14.8284 4 14C4 13.1716 4.67157 12.5 5.5 12.5ZM11 12.5C11.8284 12.5 12.5 13.1716 12.5 14C12.5 14.8284 11.8284 15.5 11 15.5C10.1716 15.5 9.5 14.8284 9.5 14C9.5 13.1716 10.1716 12.5 11 12.5Z"
                        fill={currentIndex === 8 ? ColorTheme.Black.color : ColorTheme.Grey.color}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_63738_12150">
                        <rect width="22" height="22" fill="white" />
                    </clipPath>
                </defs>
            </MobileNavbarMenuSVG>
        );
    }
    if (text === "Listings") {
        return (
            <MobileNavbarMenuSVG width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={alt}>
                <g clipPath="url(#clip0_66042_12799)">
                    <mask id="path-1-inside-1_66042_12799" fill="white">
                        <path d="M18 5H21C22.6569 5 24 6.34315 24 8V21C24 22.6569 22.6569 24 21 24H18V5Z"/>
                    </mask>
                    <path d="M18 3.4H21C23.5405 3.4 25.6 5.45949 25.6 8L22.4 8C22.4 7.2268 21.7732 6.6 21 6.6H18V3.4ZM24 24H18H24ZM18 24V5V24ZM21 3.4C23.5405 3.4 25.6 5.45949 25.6 8V19.4C25.6 21.9405 23.5405 24 21 24H21C21.7732 24 22.4 22.6569 22.4 21V8C22.4 7.2268 21.7732 6.6 21 6.6L21 3.4Z" fill={currentIndex === 9 ? ColorTheme.Black.color : ColorTheme.Grey.color} mask="url(#path-1-inside-1_66042_12799)"/>
                    <mask id="path-3-inside-2_66042_12799" fill="white">
                        <path d="M24 18V21C24 22.6569 22.6569 24 21 24L8 24C6.34315 24 5 22.6569 5 21V18L24 18Z"/>
                    </mask>
                    <path d="M25.6 18V21C25.6 23.5405 23.5405 25.6 21 25.6L21 22.4C21.7732 22.4 22.4 21.7732 22.4 21V18H25.6ZM5 24V18V24ZM5 18L24 18L5 18ZM25.6 21C25.6 23.5405 23.5405 25.6 21 25.6L9.6 25.6C7.05949 25.6 5 23.5405 5 21V21C5 21.7732 6.34315 22.4 8 22.4L21 22.4C21.7732 22.4 22.4 21.7732 22.4 21L25.6 21Z" fill={currentIndex === 9 ? ColorTheme.Black.color : ColorTheme.Grey.color} mask="url(#path-3-inside-2_66042_12799)"/>
                    <rect x="0.8" y="0.8" width="17.4" height="17.4" rx="2.2" stroke={currentIndex === 9 ? ColorTheme.Black.color : ColorTheme.Grey.color} strokeWidth="1.6"/>
                    <mask id="path-6-inside-3_66042_12799" fill="white">
                        <path d="M5 18L5 21C5 22.6569 6.34315 24 8 24L21 24C22.6569 24 24 22.6569 24 21V18L5 18Z"/>
                    </mask>
                    <path d="M3.4 18L3.4 21C3.4 23.5405 5.45949 25.6 8 25.6L8 22.4C7.2268 22.4 6.6 21.7732 6.6 21V18H3.4ZM24 24V18V24ZM24 18L5 18L24 18ZM3.4 21C3.4 23.5405 5.45949 25.6 8 25.6L19.4 25.6C21.9405 25.6 24 23.5405 24 21V21C24 21.7732 22.6569 22.4 21 22.4L8 22.4C7.2268 22.4 6.6 21.7732 6.6 21L3.4 21Z" fill={currentIndex === 9 ? ColorTheme.Black.color : ColorTheme.Grey.color} mask="url(#path-6-inside-3_66042_12799)"/>
                </g>
                <defs>
                    <clipPath id="clip0_66042_12799">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </MobileNavbarMenuSVG>
        );
    }

    return null;
}

interface MobileNavbarMenuItemNavProps {
    color: string;
    url: string;
    text: string;
    alt: string;
    currentIndex: number;
}

function MobileNavbarMenuItemNav({ color, url, text, alt, currentIndex }: MobileNavbarMenuItemNavProps) {
    let navigate = useNavigate();
    const [searchFilters, setSearchFilters] = useRecoilState(searchFiltersSelector);
    const handleMobileNavbarMenuItenInteraction = () => {
        if (url === "/") {
            const searchFiltersCopy = JSON.parse(JSON.stringify(searchFilters));
            // category removed
            setSearchFilters(searchFiltersCopy);
            navigate(url);
        } else {
            navigate(url);
        }
    };
    return (
        <MobileNavbarMenuItem
            onTouchEnd={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleMobileNavbarMenuItenInteraction();
            }}
            onClick={handleMobileNavbarMenuItenInteraction}
        >
            <MobileNavbarMenuItemSVG text={text} currentIndex={currentIndex} alt={alt} />
        </MobileNavbarMenuItem>
    );
}
